module.exports = __webpack_public_path__ + "static/media/icon-send-with-border.41bc43b8.svg";